module.exports = __webpack_public_path__ + "static/img/bigben.15e0de5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/bigben.jpg
// module id = M+lj
// module chunks = 1